import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";

import CustomButton from "../../../common/CustomButton";
import CustomCalendar from "../../../common/CustomCalendar";
import WorkoutCard from "../../homeV2/SubComponents/WorkoutCard";

import useDate from "../../../hooks/useDate";
import { MonthsFull } from "../../../constants/index"
import { GetNextWorkout } from "../../../redux/v2/user/actions";
import { GetWholeWorkoutByProgram } from "../../../redux/v2/workout/actions";

function SlideWorkoutPlan(props) {

    const { workoutPlan } = props;
    const { workoutHistory, account, allWorkoutHistory } = props.User;
    const { groupedWorkouts } = props.Workout;
    const { programs } = props.Program;


    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateSchedule, setSelectedDateSchedule] = useState(null);
    const [workout, setWorkout] = useState(null);
    const [program, setProgram] = useState(null);
    const [pointDate, setPointDate] = useState(null);
    const [allWorkouts, setAllWorkouts] = useState(null);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];

    const { GetMonthDates, GetWeekDetails, calendarMatrix } = useDate({
        workoutPlan: workoutPlan?.schedule || {}, pointDate: pointDate, groupedWorkouts: groupedWorkouts, workoutHistory: allWorkoutHistory, programs
    });

    const { year, month, day } = GetMonthDates(new Date());
    const { dayPosition, dayOrder } = GetWeekDetails();
    const calendar = calendarMatrix;

    // const calendar = GetCalendarMatrixV2(workoutPlan ? workoutPlan?.schedule : {}, pointDate);

    useEffect(() => {
        // remove workouts that are already in workout history
        if (allWorkouts?.length && allWorkoutHistory?.length) {
            const filteredWorkouts = allWorkouts.filter((workout) => {
                return !allWorkoutHistory.some((history) => history.workout_id === workout.id);
            });
            setAllWorkouts(filteredWorkouts);
        }

    }, [allWorkouts?.length]);

    useEffect(() => {

        const cb = async () => {
            const programs = onboardingDetail?.programs?.split(",") || [];
            let temp = [], allWorkouts = [];
            for (let x = 0; x < programs.length; x++) {
                temp = programs[x]?.split("-");
                const workouts = await props.GetWholeWorkoutByProgram(temp?.[0] * 1, (temp?.[1] || 0) * 1, true);
                allWorkouts = [...allWorkouts, ...workouts];
            }

            setAllWorkouts(allWorkouts);
        }

        if (onboardingDetail?.created_at) {
            setPointDate(onboardingDetail?.created_at);
            cb();
        }
    }, [onboardingDetail?.created_at]);

    useEffect(() => {
        const cb = async () => {
            if (workoutPlan) {
                setWorkout(null);
                setProgram(selectedDateSchedule?.program || null);
                setWorkout(selectedDateSchedule?.workout || null);
            }
        };

        cb();
    }, [selectedDate, workoutPlan]);

    // useEffect(() => {
    //     const cb = async () => {
    //         if (workoutPlan) {
    //             setWorkout(null);
    //             const sd = selectedDate || { year, month, day, dayPosition, dayOrder };
    //             let calendarDates = [];
    //             for (let x = 0; x < calendar?.calendar?.length; x++) {
    //                 calendarDates = [...calendarDates, ...calendar?.calendar[x]];
    //             }
    //             let scheduledProgram = calendarDates.find((c) => c?.day == sd?.day && c?.month == sd?.month && c?.year == sd?.year);
    //             scheduledProgram = scheduledProgram?.schedule?.program || null;
    //             setProgram(scheduledProgram);
    //             if (scheduledProgram?.id) {
    //                 const res = await props.GetNextWorkout(scheduledProgram?.id, [], scheduledProgram?.occurence);
    //                 setWorkout(res);
    //             }

    //         }
    //     };

    //     cb();
    // }, [selectedDate, workoutPlan]);


    const sd = selectedDate || { year, month, day, dayPosition, dayOrder };

    return (
        <div id="uo-workout-plan" className="uo-component">
            <div id="uo-goal-form" className="ou-with-text" >
                <h4>Preview Your Schedule</h4>
                {/* <h6>{MonthsFull[month]}</h6> */}
                <h6>We’ve built you a custom
                    schedule to keep you moving
                    and build your strength!</h6>

                <CustomCalendar
                    // onboarding={true}
                    showHeader={true}
                    highlights={{
                        type: "week",
                        values: calendar?.highlights ? calendar?.highlights : {}
                    }}
                    calendarDates={calendar}
                    tags={{ 5: "circle-question" }}
                    onChange={(data) => {
                        setSelectedDate({ ...data?.cell });
                        setSelectedDateSchedule({ ...data?.cellData });
                    }}
                />

                <div id="uo-workout-plan-workout-card" className="ydb-banner">
                    <div className="ydb-banner-description">
                        <h4>{moment(new Date(`${sd?.year}/${sd?.month}/${sd?.day}`)).format('MMMM Do YYYY')}</h4>
                        {!workout && <p>Rest Day!</p>}
                    </div>
                    {workout && <div className="ydb-banner-card-wrapper">
                        <WorkoutCard isFavorite={false} video={workout} program={program} disableLink={true} />
                    </div>}
                </div>

                <CustomButton id="uo-sg-button" className="uo-button active" onClick={() => {
                    props?.moveNext();
                }}>Continue</CustomButton>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Workout: state.Workout,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetNextWorkout,
    GetWholeWorkoutByProgram,
})(SlideWorkoutPlan);